import { getCookie, setCookie, removeCookie, Cookies } from '@chegg-wt/core/utils/cookies'
import { Config } from '@chegg-wt/core/config'

export interface PaperUploadedCookie {
  sessionId: string
  cheggUserUuid?: string
}

export const CookieExpiresInDays = 7

export const getPaperUploadedCookie = (): null | PaperUploadedCookie => {
  const cookie = getCookie(Cookies.PaperUploaded)
  if (!cookie) {
    return null
  }

  try {
    return JSON.parse(cookie)
  } catch {
    return null
  }
}

export const hasPaperUploaded = (sessionId: string, cheggUserUuid?: string): boolean => {
  const cookie = getPaperUploadedCookie()
  if (!cookie) {
    return false
  }

  const { sessionId: sessionIdCookie, cheggUserUuid: cheggUserUuidCookie } = cookie

  if (cheggUserUuid && cheggUserUuidCookie && cheggUserUuid === cheggUserUuidCookie) {
    return true
  }

  if (sessionIdCookie && sessionId === sessionIdCookie) {
    return true
  }

  return false
}

export const setPaperUploaded = (sessionId: string, cheggUserUuid?: string): void => {
  const cookiePayload: PaperUploadedCookie = {
    sessionId,
    cheggUserUuid,
  }
  setCookie(Cookies.PaperUploaded, JSON.stringify(cookiePayload), {
    domain: Config.cookieDomain,
    expires: CookieExpiresInDays,
  })
}

export const removePaperUploadedCookie = (): void => removeCookie(Cookies.PaperUploaded)
